import { AddCircle } from '@mui/icons-material';
import { EdgeProps } from 'reactflow';

const CustomEdge = (props: EdgeProps) => {
  const { id, sourceX, sourceY, targetX, targetY, style, data } = props;

  // Check if connection is optional
  const isOptional = data?.is_optional || false;

  // Calculate the midpoint X and Y positions for horizontal layout
  const midX = (sourceX + targetX) / 2;
  const midY = (sourceY + targetY) / 2;
  
  // Create smooth curved path for horizontal layout
  const path = `M ${sourceX} ${sourceY} 
                C ${midX} ${sourceY}, ${midX} ${targetY}, ${targetX} ${targetY}`;

  // Dynamic edge styling based on optional status (Option E)
  // Required: solid line, blue (#6366f1)
  // Optional: dashed line (8 4 pattern), gray (#9CA3AF)
  const edgeStyle = {
    ...style,
    stroke: isOptional ? '#B1B1B1' : '#5f91ed',
    strokeWidth: 2,
    strokeDasharray: '8 4',
  };

  // Circle and icon color based on optional status
  const circleStrokeColor = isOptional ? '#9CA3AF' : '#6366f1';
  const iconColorClass = isOptional 
    ? 'text-gray-500 hover:text-gray-600' 
    : 'text-blue-500 hover:text-blue-600';

  return (
    <g>
      {/* Edge path with optional styling */}
      <path
        id={id}
        style={edgeStyle}
        className="react-flow__edge-path"
        d={path}
      />
      
      {/* Circle background for the plus icon */}
      <circle
        cx={midX}
        cy={midY}
        r={12}
        fill="white"
        stroke={circleStrokeColor}
        strokeWidth={2}
      />

      {/* AddCircle icon in the center */}
      <foreignObject
        width={24}
        height={24}
        x={midX - 12}
        y={midY - 12}
        className="edgebutton-foreignobject"
        style={{ overflow: 'visible' }}
      >
        <div style={{ width: '100%', height: '100%' }}>
          <AddCircle 
            fontSize="small"
            className={`cursor-pointer ${iconColorClass}`}
            sx={{ width: 24, height: 24 }}
            onClick={(e) => {
              e.stopPropagation();
              if (data?.onAddNode) {
                const parts = id.split('_');
                const startNode = parts[1];
                const endNode = parts[2];
                data.onAddNode(startNode, endNode);
              }
            }}
          />
        </div>
      </foreignObject>
    </g>
  );
};

export default CustomEdge; 
